export default "__VITE_ASSET__oMwBuzRS__"